import { ClaimHistoryContainer } from './claim-history.container';

export { claimsReducer } from './state/claims.reducer';
export { claimsSaga } from './state/claims.saga';
export default ClaimHistoryContainer;
